export default __webpack_public_path__ + "08ec61cd70f6363df2b28a38b1b704dd.woff2";